import React, { useState } from "react";
import { Link } from "wouter";
import { AxiosError } from 'axios';
import { XCircleIcon, EyeIcon, EyeSlashIcon, CheckCircleIcon } from "@heroicons/react/24/outline";
import { singupShort } from "../services/api"



export default function Registrazione() {
  const dataRef = React.useRef({});
  const errorRef = React.useRef(null);
  const successRef = React.useRef(null);
  const [loading, setLoading] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
  const [termsChecked, setTermsChecked] = useState(false);
  const [privacyChecked, setPrivacyChecked] = useState(false);
  const [typology, setTypology] = useState("");
  const [error, setError] = useState(null);


  React.useEffect(() => {
    if(error) {
        errorRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [error]);

  React.useEffect(() => {
    if(success) {
        successRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [success]);

  const togglePasswordVisibility = () => {
      setPasswordVisible(!passwordVisible);
  };

  const toggleConfirmPasswordVisibility = () => {
      setConfirmPasswordVisible(!confirmPasswordVisible);
  };

  const handleTypologyChange = (e) => {
    setTypology(e.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError(null);

    if (!termsChecked || !privacyChecked) {
      setError('Termini e Privacy sono obbligatori');
      return;
    }

    if (typology === "A" && !event.target.business_name.value) {
        setError("Il campo Denominazione è obbligatorio per la tipologia Azienda.");
        return;
    }

    const fields = Array.from(dataRef.current.querySelectorAll('input, select')).reduce((prev, curr) => {
        console.log(prev, curr)
        prev[curr.id] = curr.value

        return prev;
    }, {});

    const formData = {
      email: fields.email,
      first_name: fields.first_name,
      last_name: fields.last_name,
      business_name: fields?.business_name,
      phone: fields.phone,
      password: fields.password,
      password_confirm: fields.password_confirm,
      typology: fields.typology,
    };

    setLoading(true);

    try {
      const response = await singupShort(formData);
      setSuccess(true);
      console.log("Registrazione avvenuta con successo", response);
    } catch (error) {
      setError(error.response.data.error);
      console.error("Errore durante la registrazione", error);
    } finally {
      setLoading(false);

    }
};


return (
    <>
        <div
            id="main_bg"
            style={{
                minHeight: '100vh',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundAttachment: 'fixed',
            }}
        >
            <div className="flex flex-col items-center justify-center min-h-screen px-4">

                <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-white mb-3">
                    Registrazione
                </h2>
                {/* <h4 className="text-center font-semibold tracking-wider text-white mb-3">Registrati per utilizzare la prova gratuita di 15 giorni</h4> */}
                <blockquote className="text-xl font-semibold text-center text-white mb-6">
                    Registrati per utilizzare la
                    <span className="before:block before:absolute before:-inset-1 before:-skew-y-3 before:bg-green-600 relative inline-block mx-2">
                        <span className="relative text-white">prova gratuita</span>
                    </span>
                    di 15 giorni.
                </blockquote>
                {error && (
                    <div className="rounded-md bg-red-50 p-4 mb-6">
                        <div className="flex">
                            <div className="flex-shrink-0">
                                <XCircleIcon className="h-5 w-5 text-red-400" />
                            </div>
                            <div className="ml-3">
                                <h3 className="text-sm font-medium text-red-800" ref={errorRef}>
                                    {error}
                                </h3>
                            </div>
                        </div>
                    </div>
                )}

                <div className="bg-white shadow-lg rounded-lg w-full p-8" style={{ backgroundColor: 'white', width: '90%' }}>
                    {success ? (
                        <>
                            <div className="rounded-md bg-green-50 p-4 mb-6">
                                <div className="flex">
                                    <div className="flex-shrink-0">
                                        <CheckCircleIcon className="h-5 w-5 text-green-400" />
                                    </div>
                                    <div className="ml-3">
                                        <h3 className="text-sm font-medium text-green-800" ref={successRef}>
                                                Registrazione avvenuta con successo!{" "}Hai ricevuto una email con le credenziali.{" "}
                                            <Link
                                                to="/login"
                                                className="text-indigo-600 underline"
                                            >
                                                Clicca qui per effettuare il login.
                                            </Link>
                                        </h3>
                                    </div>
                                </div>
                            </div>
                        </>
                    ) : (
                        <form onSubmit={handleSubmit} ref={dataRef}>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                                {/* Prima colonna */}
                                <div>
        
                                    <div className="mb-4">
                                        <label
                                            className="block text-gray-700 text-sm font-bold mb-2"
                                            htmlFor="typology"
                                        >
                                            Tipologia
                                        </label>
                                        <select
                                            className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                                            id="typology"
                                            placeholder="typology"
                                            onChange={handleTypologyChange}
                                            required
                                        >
                                            <option value="">---</option>
                                            <option value="A">Azienda</option>
                                            <option value="PF">Persona fisica</option>
                                        </select>
                                    </div>


                                    
                                    <div className="mb-4">
                                        <label
                                            className="block text-gray-700 text-sm font-bold mb-2"
                                            htmlFor="email"
                                        >
                                            Email
                                        </label>
                                        <input
                                            className="shadow-md appearance-none border border-gray-200 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-indigo-200 placeholder:text-sm"
                                            id="email"
                                            type="email"
                                            placeholder="Email"
                                            required
                                        />
                                    </div>

                                    <div className="mb-4">
                                        <label
                                            className="block text-gray-700 text-sm font-bold mb-2"
                                            htmlFor="first_name"
                                        >
                                            Nome
                                        </label>
                                        <input
                                            className="shadow-md appearance-none border border-gray-200 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-indigo-200 placeholder:text-sm"
                                            id="first_name"
                                            type="text"
                                            placeholder="Nome"
                                            required
                                        />
                                    </div>
                                
                                    <div className="mb-4">
                                        <label
                                            className="block text-gray-700 text-sm font-bold mb-2"
                                            htmlFor="last_name"
                                        >
                                            Cognome
                                        </label>
                                        <input
                                            className="shadow-md appearance-none border border-gray-200 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-indigo-200 placeholder:text-sm"
                                            id="last_name"
                                            type="text"
                                            placeholder="Cognome"
                                            required
                                        />
                                    </div>

                                    <div className="mb-4">
                                        <label
                                            className="block text-gray-700 text-sm font-bold mb-2"
                                            htmlFor="business_name"
                                        >
                                            Denominazione Azienda
                                        </label>
                                        <input
                                            className="shadow-md appearance-none border border-gray-200 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-indigo-200 placeholder:text-sm"
                                            id="business_name"
                                            type="text"
                                            placeholder="Denominazione Azienda"
                                        />
                                    </div>

                                    <div className="mb-4">
                                        <label
                                            className="block text-gray-700 text-sm font-bold mb-2"
                                            htmlFor="phone_number"
                                        >
                                            Telefono
                                        </label>
                                        <input
                                            className="shadow-md appearance-none border border-gray-200 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-indigo-200 placeholder:text-sm"
                                            id="phone"
                                            type="tel"
                                            placeholder="Telefono"
                                
                                            required
                                        />
                                    </div>

                                    <div className="mb-4 relative">
                                        <label
                                            className="block text-gray-700 text-sm font-bold mb-2"
                                            htmlFor="password"
                                        >
                                            Password
                                        </label>
                                        <input
                                            className="shadow-md appearance-none border border-gray-200 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-indigo-200 placeholder:text-sm"
                                            id="password"
                                            type={passwordVisible ? 'text' : 'password'}
                                            placeholder="Password"
                                            style={{ backgroundColor: 'white' }}
                                            required
                                        />
                                        <div
                                            className="absolute inset-y-0 right-0 top-1/2 flex items-center px-2 cursor-pointer"
                                            onClick={togglePasswordVisibility}
                                        >
                                            {passwordVisible ? (
                                                <EyeSlashIcon className="h-5 w-5 text-gray-700" />
                                            ) : (
                                                <EyeIcon className="h-5 w-5 text-gray-700" />
                                            )}
                                        </div>
                                    </div>

                                    {/* Conferma Password */}
                                    <div className="mb-6 relative">
                                        <label
                                            className="block text-gray-700 text-sm font-bold mb-2"
                                            htmlFor="confirm-password"
                                        >
                                            Conferma Password
                                        </label>
                                        <input
                                            className="shadow-md appearance-none border border-gray-200 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-indigo-200 placeholder:text-sm"
                                            id="password_confirm"
                                            type={confirmPasswordVisible ? 'text' : 'password'}
                                            placeholder="Conferma Password"
                                            required
                                        />
                                        <div
                                            className="absolute inset-y-0 right-0 top-1/2 flex items-center px-2 cursor-pointer"
                                            onClick={toggleConfirmPasswordVisibility}
                                        >
                                            {confirmPasswordVisible ? (
                                                <EyeSlashIcon className="h-5 w-5 text-gray-700" />
                                            ) : (
                                                <EyeIcon className="h-5 w-5 text-gray-700" />
                                            )}
                                        </div>
                                    </div>

                                    <div className="mb-6">
                                        <label className="inline-flex items-center text-gray-700">
                                            <input
                                                type="checkbox"
                                                id="terms"
                                                className="rounded border-gray-300 shadow-md text-indigo-600 focus:ring-indigo-600"
                                                checked={termsChecked}
                                                onChange={(e) => setTermsChecked(e.target.checked)}
                                                required
                                            />
                                            <span className="text-gray-700 text-sm font-bold ml-2">Accetto le <a href="https://consultala.com/termini/" target="_blank" className="text-indigo-600 hover:underline">Condizioni Generali</a></span>
                                        </label>
                                    </div>
                                    
                                    <div className="mb-6">
                                        <label className="inline-flex items-center text-gray-700">
                                            <input
                                                type="checkbox"
                                                id="privacy"
                                                className="rounded border-gray-300 shadow-md text-indigo-600 focus:ring-indigo-600"
                                                checked={privacyChecked}
                                                onChange={(e) => setPrivacyChecked(e.target.checked)}
                                                required
                                            />
                                            <span className="text-gray-700 text-sm font-bold ml-2">Accetto la <a href="https://consultala.com/privacy/" target="_blank" className="text-indigo-600 hover:underline">Privacy Policy</a></span>
                                        </label>
                                    </div>
                                    
                                </div>
                                
                                <div 
                                    id="main_bg"
                                    style={{
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center',
                                        backgroundAttachment: 'fixed',
                                        opacity: '80%',
                                        backgroundColor: '#6366f1',
                                    }} 
                                    className="p-4 rounded-lg shadow-lg border border-gray-200 bg-white"
                                >
                                    <h1 className="text-lg text-white font-bold mb-3 ">
                                        Benvenuto!
                                    </h1>
                                    <h1 className="text-md text-white font-bold mb-3">
                                        Rivoluziona la gestione del personale della tua azienda con Consultala HR, attraverso un’unica piattaforma semplice e intuitiva, sia per te che per i tuoi dipendenti.
                                    </h1>
                                    <h1 className="text-md text-white font-semibold">
                                        Grazie a Consultala HR puoi gestire nello stesso posto:
                                        <br /><span className="inline-block mt-3"> ✅ Trasmissione e archiviazione di buste paga, certificazioni uniche e altri documenti</span>
                                        <br /><span className="inline-block mt-3"> ✅ Gestione dei turni e integrazione con il calendario delle presenze, per avere una visione d’insieme sull’organico semplificata e sempre aggiornata</span> 
                                        <br /><span className="inline-block mt-3"> ✅ Richiesta e accettazione di giustificativi come ferie, permessi, malattia, maternità, congedi e tanti altri ancora</span> 
                                        <br /><span className="inline-block mt-3"> ✅ Gestione delle note spese e dei rimborsi chilometrici</span>
                                        <br /><span className="inline-block mt-3"> ✅ Timbrature geolocalizzate per monitorare l’attività dei tuoi dipendenti</span>
                                        <br /><span className="inline-block my-3"> ✅ Trasmissione di avvisi aziendali, selezionando i destinatari uno ad uno o filtrandoli attraverso le loro unità organizzative di appartenenza</span>
                                    </h1>
                                    <h1 className="text-md text-white font-bold mb-3">
                                        L’archiviazione nel nostro cloud è sicura e protetta e consente l’accesso ai dati da qualsiasi luogo, eliminando il rischio di perdere documenti importanti, neutralizzando qualsiasi passaggio cartaceo e permettendoti di risparmiare tempo prezioso.
                                    </h1> 
                                    <h1 className="text-md text-white font-bold mb-3">
                                        Accedendo con le proprie credenziali sul sito di Consultala HR o sull’applicazione dedicata, ogni dipendente può facilmente scaricare la propria documentazione, ricevere le comunicazioni aziendali e inoltrare tutte le sue richieste.
                                    </h1> 
                                </div>
                            </div>

                            <div className="flex justify-center mt-8">
                                {loading ? (
                                    <button
                                        type="button"
                                        className="bg-indigo-500 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                                        disabled
                                    >
                                        <svg
                                        className="animate-spin h-5 w-5 mr-3"
                                        viewBox="0 0 24 24"
                                        >
                                        <circle
                                            cx="12"
                                            cy="12"
                                            r="10"
                                            stroke="currentColor"
                                            strokeWidth="4"
                                            fill="none"
                                        />
                                        </svg>
                                        Elaborazione...
                                    </button>
                                ) : (
                                    <button
                                        type="submit"
                                        className="bg-indigo-600 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                                        disabled={success}
                                    >
                                        Crea Account
                                    </button>
                                )}
                            </div>
                        </form>
                    )}
                </div>
            </div>
        </div>
    </>
  )
}
